<template>
  <b-col offset="1">
    <column-picker :column="leftColumn" :required="isRequired" @change="update"
                   :columnSpecCategories="columnSpecCategories" :reportType="reportType" :report="report"
                   defaultOptionText="Please choose an option" :isGrouping="false" :isSubGrouping="false"
                   :isAggregate="isAggregate" :hasLabel="false" :allowedDataTypes="allowedDataTypes">
    </column-picker>
    <b-form-group>
      <b-input-group prepend="... is: " append="...">
        <b-form-select v-model="operator" @change="update">
          <option value="null" disabled>Please select an option</option>
          <option value="<">Less than</option>
          <option value="<=">Less than or equal to</option>
          <option value="=">Equal to</option>
          <option value=">=">Greater than or equal to</option>
          <option value=">">Greater than</option>
        </b-form-select>
      </b-input-group>
    </b-form-group>
    <column-picker :column="rightColumn" :required="isRequired" @change="update"
                   :columnSpecCategories="columnSpecCategories" :reportType="reportType" :report="report"
                   defaultOptionText="Please choose an option" :isGrouping="false" :isSubGrouping="false"
                   :isAggregate="isAggregate" :hasLabel="false" :allowedDataTypes="allowedDataTypes">
    </column-picker>
  </b-col>
</template>

<script>

export default {
  name: 'comparison-column-options',
  props: ['column', 'columnSpec', 'isRequired', 'columnSpecCategories', 'reportType', 'report', 'isRequired', 'isAggregate'],
  components: { 'column-picker': () => import('@/components/reports/ColumnPicker') },
  data () {
    return {
      leftColumn: this.column.sub_columns[0] || { column_id: null, label: null, sub_columns: [], options: {} },
      rightColumn: this.column.sub_columns[1] || { column_id: null, label: null, sub_columns: [], options: {} },
      operator: this.column.options.operator || '='
    }
  },
  computed: {
    allowedDataTypes () {
      return this.columnSpec.component_column_data_types
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    update () {
      this.column.sub_columns[0] = this.leftColumn
      this.column.sub_columns[1] = this.rightColumn
      this.column.options = { operator: this.operator }
      this.emitChange()
    },
    emitChange () {
      this.$emit('change', this.column)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/ComparisonColumnOptions.vue